<div class="main-container">
  <div class="mdl-container">
    <div class="d-grid mdl-header">
      <div class="center-svg"><img src="assets/svg/name-icon.svg" alt=""></div>
      <div>
        <h4 class="text-semibold">Filtrar metas</h4>
        <h6 class="color-gray" style="font-weight: 400;">Selecciona los criterios para filtrar la vista de metas.</h6>
      </div>
      <div>
        <h3 class="color-gray text-semibold">
          <div class="center-svg">
            <img (click)="closeMdl();" class="close-button" src="assets/svg/close-icon.svg" alt="">
          </div>
        </h3>
      </div>
    </div>

    <form>
      <div class="filter-section">
        <label class="section-title">Estado de la meta</label>
        <div class="filter-options">
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.allStatuses" name="allStatuses" (change)="toggleAllStatuses()">
            <span class="crm-checkbox-custom"></span>
            Todos los estados
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.statuses.sinIniciar" name="sinIniciar" (change)="onStatusChange()">
            <span class="crm-checkbox-custom"></span>
            Sin iniciar
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.statuses.enCurso" name="enCurso" (change)="onStatusChange()">
            <span class="crm-checkbox-custom"></span>
            En curso
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.statuses.incompleto" name="incompleto" (change)="onStatusChange()">
            <span class="crm-checkbox-custom"></span>
            Incompleto
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.statuses.completado" name="completado" (change)="onStatusChange()">
            <span class="crm-checkbox-custom"></span>
            Completado
          </label>
        </div>
      </div>

      <div class="filter-section">
        <label class="section-title">Metas marcadas</label>
        <div class="filter-options">
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.allFavorites" name="allFavorites" (change)="toggleAllFavorites()">
            <span class="crm-checkbox-custom"></span>
            Todas las metas
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.favorites.marcadas" name="marcadas" (change)="onFavoriteChange()">
            <span class="crm-checkbox-custom"></span>
            Solo metas marcadas
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.favorites.noMarcadas" name="noMarcadas" (change)="onFavoriteChange()">
            <span class="crm-checkbox-custom"></span>
            Solo metas no marcadas
          </label>
        </div>
      </div>

      <div class="filter-section">
        <label class="section-title">Rango de progreso</label>
        <div class="options-row">
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="progressRange" [(ngModel)]="filters.progressRange" value="all">
            <span class="crm-radio-custom"></span>
            Todos
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="progressRange" [(ngModel)]="filters.progressRange" value="0-25">
            <span class="crm-radio-custom"></span>
            0% - 25%
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="progressRange" [(ngModel)]="filters.progressRange" value="26-50">
            <span class="crm-radio-custom"></span>
            26% - 50%
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="progressRange" [(ngModel)]="filters.progressRange" value="51-75">
            <span class="crm-radio-custom"></span>
            51% - 75%
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="progressRange" [(ngModel)]="filters.progressRange" value="76-100">
            <span class="crm-radio-custom"></span>
            76% - 100%
          </label>
        </div>
      </div>

      <div class="filter-section">
        <label class="section-title">Fecha de cierre</label>
        <div class="options-row">
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="dateRange" [(ngModel)]="filters.dateRange" value="all">
            <span class="crm-radio-custom"></span>
            Todas las fechas
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="dateRange" [(ngModel)]="filters.dateRange" value="7d">
            <span class="crm-radio-custom"></span>
            Próximos 7 días
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="dateRange" [(ngModel)]="filters.dateRange" value="30d">
            <span class="crm-radio-custom"></span>
            Próximos 30 días
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="dateRange" [(ngModel)]="filters.dateRange" value="vencidas">
            <span class="crm-radio-custom"></span>
            Vencidas
          </label>
        </div>
      </div>

      <hr style="margin-top: 24px;">

      <div class="filter-actions">
        <button type="button" class="btn btn-primary-outline" (click)="closeMdl()">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="applyFilters()">Aplicar filtros</button>
      </div>
    </form>
  </div>
</div>